import React from "react";
import { IconButton, Stack, Box, Tooltip, Typography } from "@mui/material";

import "./studentcard.scss";

import boy from "../../../../Assets/student.png";
import girl from "../../../../Assets/female-student.png";

export default function StudentCard({ tableData }) {
  return (
    <div className="card-student-container">
      <Stack direction="row" alignItems="center" justifyContent="center">
        <Stack
          direction="column"
          spacing={2}
          alignItems="center"
          justifyContent="center"
        >
          <Stack direction="column" className="box-photo">
            {tableData?.gender === "Male" ? (
              <img src={boy} alt="boy" className="img" />
            ) : (
              <img src={girl} alt="girl" className="img" />
            )}
          </Stack>
          <Stack
            direction="column"
            spacing={0.5}
            alignItems="center"
            justifyContent="center"
          >
            <Typography className="name-kh">
              {tableData?.full_name_kh}
            </Typography>
            <Typography className="name-en">
              {tableData?.full_name_latin}
            </Typography>
            <Typography className="name-id">
              ID : {tableData?.student_id}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </div>
  );
}
